export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID;
export const MSAL_TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID;
export const MSAL_REDIRECT_URI = import.meta.env.VITE_MSAL_REDIRECT_URI;
export const MSAL_POST_LOGOUT_REDIRECT_URI = import.meta.env
  .VITE_MSAL_POST_LOGOUT_REDIRECT_URI;
export const MSAL_SCOPES = import.meta.env.VITE_MSAL_SCOPES.split(' ');
export const API_SCOPES = import.meta.env.VITE_API_SCOPES.split(' ');
export const API_URL = import.meta.env.VITE_API_URL;
export const INVENTORY_API_URL =
  import.meta.env.VITE_INVENTORY_API_URL ??
  'https://inventory-dev.pegasus.wkcloud.io/api/v2.0';
export const INVENTORY_API_SCOPES = (
  import.meta.env.VITE_INVENTORY_API_SCOPES ??
  'api://e2872f82-31fa-4502-b6e9-4dc0babbadae/user_impersonation'
).split(' ');
export const INVENTORY_V3_API_URL =
  import.meta.env.VITE_INVENTORY_V3_API_URL ??
  'https://inventory-dev.pegasus.wkcloud.io';
export const INVENTORY_V3_API_SCOPES = (
  import.meta.env.VITE_INVENTORY_V3_API_SCOPES ??
  'api://e2872f82-31fa-4502-b6e9-4dc0babbadae/.default'
).split(' ');
export const HUB_API_URL = import.meta.env.VITE_HUB_API_URL;
export const HUB_SCOPES = import.meta.env.VITE_HUB_SCOPES.split(' ');
export const PROXY_API_BASE_URL = import.meta.env.VITE_PROXY_API_BASE_URL;
export const AI_ANALYZER_API_URL = import.meta.env.VITE_AI_ANALYZER_API_URL;
export const AI_ANALYZER_SCOPES = import.meta.env.VITE_AI_ANALYZER_SCOPES?.split(' ');
export const APPLICATIONINSIGHTS_CONNECTION_STRING = import.meta.env.VITE_APP_CONNECTION_STRING;
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || undefined;
export const SITE_COMPLIANCE_API_URL =
  import.meta.env.VITE_SC_API_URL ??
  'https://zuse2d1site-compliance-api1.azurewebsites.net';
export const SITE_COMPLIANCE_API_SCOPES = (
  import.meta.env.VITE_SC_API_SCOPES ??
  'api://ee755fa4-73f1-4f23-a91c-e8c3ced4fd65/.default'
).split(' ');
export const SC_SITES_BACKEND =
  import.meta.env.VITE_SC_SITES_BACKEND === 'api' ||
  import.meta.env.VITE_SC_SITES_BACKEND === 'inventory'
    ? import.meta.env.VITE_SC_SITES_BACKEND
    : 'inventory';
export const SITE_COMPLIANCE_PORTAL_ENABLED =
  window.location.hostname.startsWith('sites');
